import { render, staticRenderFns } from "./postPage.vue?vue&type=template&id=601ec1d0&"
import script from "./postPage.vue?vue&type=script&lang=js&"
export * from "./postPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports